/**
 * Non-blocking toasts: use `notify.*` (Sonner via `<Toaster />` in main.tsx).
 * Do not use `window.alert()` for feedback. `confirm` / `prompt` are only for
 * explicit destructive or numeric prompts, not general notices.
 */
import { toast, type ExternalToast } from 'sonner'

type ToastOpts = ExternalToast

export const notify = {
  success: (message: string, opts?: ToastOpts) => toast.success(message, opts),
  error: (message: string, opts?: ToastOpts) => toast.error(message, opts),
  info: (message: string, opts?: ToastOpts) => toast.info(message, opts),
  warning: (message: string, opts?: ToastOpts) => toast.warning(message, opts),
  message: (message: string, opts?: ToastOpts) => toast.message(message, opts),
  promise: toast.promise,
  dismiss: toast.dismiss
}
